import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Wrapper } from "app/NativeComponents/common";
import {
  appRedirect,
  updateConversation,
  getBulkEdits,
  reloadLeads,
  getBilling,
  updateBulkEdit,
  getOwnerInfoSuccess,
  getLists,
  loadRoutes
} from "app/NativeActions";
import PusherService from "app/Router/PusherService";

class PusherWrapper extends PureComponent {
  constructor(props) {
    super(props);

    // Enable pusher logging - don't include this in production
    //Pusher.logToConsole = true;
    this.handleEvent = this.handleEvent.bind(this);
  }

  componentDidMount() {
    if (this.props.user) {
      this.initPush(this.props.user);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (!prevProps.user && this.props.user) ||
      (prevProps.user && !this.props.user) ||
      (prevProps.user &&
        this.props.user &&
        prevProps.user.id !== this.props.user.id)
    ) {
      this.initPush(this.props.user);
    }
  }

  initPush(user) {
    if (this._pusher) {
      this._pusher.allChannels().forEach(channel => {
        this._pusher.unsubscribe(channel.name);
      });
    }

    if (user) {
      this._pusher = PusherService.getPusher();
      this._user_channel = this._pusher.subscribe(
        "user-" + user.user_ws_key + "-dealmachine"
      );
      this._channel = this._pusher.subscribe(
        "team-" + user.team_ws_key + "-dealmachine"
      );

      //all new sms message functions
      this._channel.bind("sms_message", data =>
        this.handleEvent(data, "sms_message")
      );
      this._channel.bind("owner", data => this.handleEvent(data, "owner"));
      this._channel.bind("leads", data => this.handleEvent(data, "leads"));

      this._channel.bind("bulk_edits", data =>
        this.handleEvent(data, "bulk_edits")
      );

      this._channel.bind("build_list", data =>
        this.handleEvent(data, "build_list")
      );

      this._user_channel.bind("routes", data =>
        this.handleEvent(data, "routes")
      );
    }
  }

  handleEvent(data, event) {
    switch (event) {
      case "sms_message":
        //get conversation from text message

        this.props.updateConversation({
          token: this.props.token,
          type: "active_conversation",
          conversation_id: data.conversation_id
        });
        break;

      case "owner":
        if (
          this.props.active_property &&
          this.props.active_property.deal &&
          this.props.active_property.deal.id == data.lead_id
        ) {
          this.props.getOwnerInfoSuccess({
            lead_id: data.lead_id,
            owners: data.owners
          });
        }

        break;

      case "leads":
        //update all leads on the front end...also get all bulk edits
        let leads = [];
        if (this.props.active_property && this.props.active_property.deal) {
          leads.push(this.props.active_property.deal.id);
        }
        if (this.props.map_properties && this.props.map_properties.length > 0) {
          for (let i = 0; i < this.props.map_properties.length; i++) {
            if (this.props.map_properties[i].deal) {
              leads.push(this.props.map_properties[i].deal.id);
            }
          }
        }
        if (
          this.props.list_properties &&
          this.props.list_properties.length > 0
        ) {
          for (let j = 0; j < this.props.list_properties.length; j++) {
            if (this.props.list_properties[j].deal) {
              leads.push(this.props.list_properties[j].deal.id);
            }
          }
        }
        var lead_ids = "";
        if (!!data.lead_ids) {
          var data_lead_ids = data.lead_ids.split(",");
          for (let k = 0; k < leads.length; k++) {
            for (let l = 0; l < data_lead_ids.length; l++) {
              if (leads[k] == data_lead_ids[l]) {
                if (lead_ids.length > 0) {
                  lead_ids += ",";
                }
                lead_ids += data_lead_ids[l];
              }
            }
          }
        } else {
          lead_ids = leads.join(",");
        }

        if (!!lead_ids) {
          this.props.reloadLeads({
            token: this.props.token,
            type: "websocket",
            updating_type: data.updating_type,
            lead_ids
          });
        }

        //update bulk edit if id is included
        if (
          data &&
          !!data.bulk_edit_id &&
          this.props.bulk_edits &&
          this.props.bulk_edits.length > 0
        ) {
          for (let i = 0; i < this.props.bulk_edits.length; i++) {
            if (this.props.bulk_edits[i].id == data.bulk_edit_id) {
              const percent_complete = parseInt(
                ((parseInt(this.props.bulk_edits[i].leads_updated) +
                  parseInt(this.props.bulk_edits[i].leads_failed) +
                  1) /
                  parseInt(this.props.bulk_edits[i].total)) *
                  100
              );

              const percent_remaining =
                100 -
                parseInt(
                  ((parseInt(this.props.bulk_edits[i].leads_updated) +
                    parseInt(this.props.bulk_edits[i].leads_failed) +
                    1) /
                    parseInt(this.props.bulk_edits[i].total)) *
                    100
                );

              this.props.updateBulkEdit({
                id: this.props.bulk_edits[i].id,
                total: this.props.bulk_edits[i].total,
                percent_complete,
                percent_remaining,
                leads_updated:
                  parseInt(this.props.bulk_edits[i].leads_updated) + 1,
                leads_failed: this.props.bulk_edits[i].leads_failed
              });
            }
          }
        }
        break;

      case "bulk_edits":
        //check status of bulk edits
        //get list update
        //data.list_id
        let matched_id = false;
        if (
          data &&
          !!data.id &&
          this.props.bulk_edits &&
          this.props.bulk_edits.length > 0
        ) {
          for (let i = 0; i < this.props.bulk_edits.length; i++) {
            if (this.props.bulk_edits[i].id == data.id) {
              matched_id = true;
              this.props.updateBulkEdit({
                id: data.id,
                completed: data.completed,
                total: data.total,
                percent_complete: data.percent_complete,
                percent_remaining: data.percent_remaining,
                leads_updated: data.leads_updated,
                leads_failed: data.leads_failed
              });
            }
          }
        }

        if (!matched_id) {
          this.props.getBulkEdits({ token: this.props.token });
          this.props.getBilling({
            token: this.props.token,
            type: "deal_credits"
          });
        }

        break;
      case "routes":
        fetch(data.routes, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          }
        })
          .then(response => response.json())
          .then(myJson => this.props.loadRoutes({ routes: myJson }));

        // console.log(routeJson);
        break;
      case "build_list":
        if (data && !!data.list_id) {
          this.props.getLists({
            token: this.props.token,
            load_type: "refresh_single_list",
            list_id: data.list_id
          });
        }
        this.props.getBilling({
          token: this.props.token,
          type: "lists_info_banner"
        });
        break;
      default:
        break;
    }
  }
  render() {
    return <Wrapper />;
  }
}

const mapStateToProps = ({ auth, property_map, lead, route }) => {
  const { token, user } = auth;
  const { active_property, map_properties } = property_map;
  const { list_properties, bulk_edits } = lead;
  const { map_routes } = route;
  return {
    map_routes,
    token,
    user,
    active_property,
    map_properties,
    list_properties,
    bulk_edits
  };
};

export default connect(mapStateToProps, {
  appRedirect,
  updateConversation,
  getBulkEdits,
  getBilling,
  reloadLeads,
  updateBulkEdit,
  getOwnerInfoSuccess,
  getLists,
  loadRoutes
})(PusherWrapper);
